var map = {
	"./InventoriStep1.gif": 4700,
	"./InventoriStep2.gif": 498,
	"./InventoriStep3.gif": 8779,
	"./InventoriStep4.gif": 7360,
	"./InventoriStep5.gif": 6436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6234;